export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./videoResource.vue?vue&type=template&id=5ab7e110&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/videoResource.vue?vue&type=template&id=5ab7e110&scoped=true&
// module id = null
// module chunks = 